import { useEffect, useState } from "react";
import api from "./api";

export const usePaginatedPost = (url, payload, cursor) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLastPage, setIsLastPage] = useState(false);
    const [nextCursor, setNextCursor] = useState(null);

    const payloadString = JSON.stringify(payload || {});

    useEffect(() => {
        if (!cursor) {
            setData([]);
            setIsLastPage(false);
            setNextCursor(null);
        }
    }, [url, payloadString, cursor]);

    useEffect(() => {
        if (!url) return;

        if (isLastPage && cursor !== null) return;

        const controller = new AbortController();
        let isMounted = true;

        async function fetchData() {
            try {
                setLoading(true);

                const parsedPayload = JSON.parse(payloadString) || {};
                const requestPayload = {
                    ...parsedPayload,
                    cursor: cursor || null,
                    page: cursor || 1
                };


                const response = await api.post(url, requestPayload, {
                    signal: controller.signal,
                });

                const res = response.data;

                if (isMounted) {
                    // گرفتن دیتای آرایه‌ای
                    const newData = res.data?.data || res.data || [];

                    // تغییر مهم 2: محاسبه کرسر (صفحه) بعدی بر اساس current_page
                    let returnedNextCursor = res.next || res.data?.next || null;

                    if (!returnedNextCursor && res.data?.current_page) {
                        const currentPage = res.data.current_page;
                        const lastPage = res.data.last_page;

                        // اگر last_page داریم و به آن رسیده‌ایم، یا دیتای جدیدی نیامده
                        if ((lastPage && currentPage >= lastPage) || newData.length === 0) {
                            returnedNextCursor = null;
                        } else {
                            returnedNextCursor = currentPage + 1;
                        }
                    }

                    if (newData.length === 0 || !returnedNextCursor) {
                        setIsLastPage(true);
                    } else {
                        setIsLastPage(false);
                    }

                    setNextCursor(returnedNextCursor);

                    setData(prev => {
                        if (!cursor) return newData;
                        return [...prev, ...newData];
                    });
                }

            } catch (err) {
                if (isMounted && err.name !== "CanceledError" && err.code !== "ERR_CANCELED") {
                    setError(err.message);
                    console.error("Pagination Error:", err);
                }
            } finally {
                if (isMounted) setLoading(false);
            }
        }

        fetchData();

        return () => {
            isMounted = false;
            controller.abort();
        };

    }, [url, cursor, payloadString]);

    return { data, loading, error, isLastPage, nextCursor, setData };
};
